export default __webpack_public_path__ + "static/media/kitchen3-afterK-2048w.b45660f4.avif";